<template>
	<div class="assistant-card assistant-card-row">
		<v-icon small aria-hidden="true">
			{{ card.kind === "link" ? "mdi-open-in-new" : "mdi-file-pdf-box" }}
		</v-icon>
		<span class="assistant-card-title">{{ card.fileName }}</span>
		<v-btn
			v-if="safeUrl"
			small
			text
			color="primary"
			class="assistant-card-action"
			:href="card.url"
			target="_blank"
			rel="noopener"
		>
			{{ card.kind === "link" ? "Open" : "Download" }}
		</v-btn>
	</div>
</template>

<script>
export default {
	name: "AttachmentCard",
	props: { card: { type: Object, required: true } },
	computed: {
		safeUrl() {
			const url = this.card.url || "";
			return url.startsWith("/") || /^https?:\/\//i.test(url);
		},
	},
};
</script>
